import { QiraMessageContentChunk, Source } from 'api3';
import { CUSTOM_ELEMENTS_SCHEMA, Component, HostListener, Input, ViewChild, effect, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService, QiraSystemGroup } from '@app/services/message.service';
import { SmartSearchFilterComponent } from '@app/chat/components/smart-search/smart-search-filter/smart-search-filter.component';
import { SmartSearchComponent } from '../smart-search.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { ListboxModule } from 'primeng/listbox';
import { TextareaModule } from 'primeng/textarea';

type SmartSearchModalData = {
  content: QiraMessageContentChunk[];
  tabId: string;
  question?: string;
};

@Component({
  selector: 'app-smart-search-modal',
  templateUrl: './smart-search-modal.component.html',
  imports: [ButtonModule, TranslocoPipe, FormsModule, TextareaModule, ListboxModule, SmartSearchFilterComponent, SmartSearchComponent],
  standalone: true,
  // Is needed this to support aria-label on the <p-button>
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SmartSearchModalComponent {
  // Props are injected by ModalComponent
  data = input<SmartSearchModalData>();
  @Input() close: (() => void) | undefined;

  @ViewChild(SmartSearchFilterComponent) filter!: SmartSearchFilterComponent;
  @HostListener('click')
  onClick() {
    this.filter?.closePopover();
  }

  messageService = inject(MessageService);

  messages: QiraMessageContentChunk[] = [];
  tabId: string | undefined;

  message = signal<string>('');
  selectedDocumentTypes = signal<Source['subject'][]>([]);
  selectedProviders = signal<Source['provider'][]>([]);
  filteredGroups = signal<QiraSystemGroup[]>([]);

  init = effect(() => {
    this.messages = this.data()?.content || [];
    this.tabId = this.data()?.tabId;
    this.message.set(this.data()?.question || '');
  });
}
